const en_purch_recap = {
    "": "purchase invoice recap",
    add: "add purchase invoice recap",
    detail: "purchase invoice recap detail",

    label: {
        no_recap_inv: "recap invoice no",
        download_inv: "download invoice proof",
    },

    error: {
        create: "Failed to create purchase invoice recap.",
        edit: "Failed to update purchase invoice recap.",
    },

    success: {
        create: "Purchase invoice recap created successfully.",
        edit: "Purchase invoice recap updated successfully.",
    },
}

export default en_purch_recap;